import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'

import { getTraderContactsAPI } from 'api/corporate-contacts'
import { useCorporateContactsStore } from 'store/corporateContacts'
import { DATASTATUS } from 'constants/status'

export const useCorporateContacts = () => {
  const { traderId } = useParams()
  const corporateTraderId = Number(traderId) || 0

  const corporateContactsModStatus = useCorporateContactsStore(
    (state) => state.corporateContactsModStatus
  )
  const corporateContactsModStatusSet = useCorporateContactsStore(
    (state) => state.corporateContactsModStatusSet
  )
  const corporateContactsModErrors = useCorporateContactsStore(
    (state) => state.corporateContactsModErrors
  )
  const corporateContactsModErrorsSet = useCorporateContactsStore(
    (state) => state.corporateContactsModErrorsSet
  )
  const corporateContacts = useCorporateContactsStore(
    (state) => state.corporateContacts
  )
  const corporateContactsSet = useCorporateContactsStore(
    (state) => state.corporateContactsSet
  )

  const {
    data: traderContacts,
    isLoading,
    isError,
  } = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['useCorporateContacts', corporateTraderId],
    queryFn: async () => {
      try {
        corporateContactsModStatusSet('loading')
        const response = await getTraderContactsAPI(corporateTraderId)
        if (response.outcomeCode === DATASTATUS.outcomeCode) {
          throw response
        }
        corporateContactsModStatusSet('success')
        return response.data
      } catch (e) {
        corporateContactsModStatusSet('fail')
        corporateContactsModErrorsSet(JSON.stringify(e))
        return []
      }
    },
    enabled: corporateTraderId > 0,
  })

  useEffect(() => {
    if (traderContacts) {
      corporateContactsSet(traderContacts)
    }
  }, [traderContacts, corporateContactsSet])

  return {
    corporateContacts,
    corporateContactsModStatus: isError ? 'fail' : isLoading ? 'loading' : corporateContactsModStatus,
    corporateContactsModErrors,
  }
}
